module.exports = __webpack_public_path__ + "img/Inflammation-BRCA_10X_Section2.95f8c3cc.png";